import { Link, useNavigation, useRouteLoaderData, Form, json, redirect, useNavigate, useSubmit } from "react-router-dom";
import { getAuthToken } from "../../../util/auth";
import { getApiChara } from "../../../util/getApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import classes from './EditUser.module.css';
import { FaUserEdit, FaIdCard, FaUserTag, FaPhoneAlt, FaSave, FaTimes } from 'react-icons/fa';
import ConfirmModal from "../../UI/ConfirmModal";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const EditUser = () => {
  const { t } = useTranslation();
  const userInfo = useRouteLoaderData('user-Info');
  const navigation = useNavigation();
  const navigate = useNavigate();
  const isSubmitting = navigation.state === 'submitting';

  const submit = useSubmit();
  const [showUpdateConfirm, setShowUpdateConfirm] = useState(false);
  const [pendingForm, setPendingForm] = useState(null);

  const handleSubmit = (event) => {
    event.preventDefault();
    setPendingForm(event.currentTarget);
    setShowUpdateConfirm(true);
  };

  const confirmUpdate = () => {
    if (pendingForm) {
      submit(pendingForm);
    }
    setShowUpdateConfirm(false);
  };

  function cancelHandler() {
    navigate("..");
  }

  return (
    <div style={{ maxWidth: '900px', margin: '0 auto' }}>
      <h3 className='textHead' style={{ color: 'var(--primary-color)', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>
        <FaUserEdit className="me-2" /> {t("Edit User Details")}
      </h3>
      <div className={classes.cardview}>
        <Form method="put" className={classes.form} onSubmit={handleSubmit}>

          <div className={classes.sectionHeader}>
            <FaIdCard /> {t("Personal Details")}
          </div>

          <div className="row">
            <div className="col-md-4 col-6">
              <label className={classes.label} htmlFor="firstName">{t("First Name")}</label>
              <input id="firstName" type="text" name="firstName" required defaultValue={userInfo ? userInfo?.firstName : ''} />
              <input id="userId" type="hidden" name="userId" required defaultValue={userInfo ? userInfo?.userId : ''} />
            </div>
            <div className="col-md-4 col-6">
              <label className={classes.label} htmlFor="middleName">{t("Middle Name")}</label>
              <input id="middleName" type="text" name="middleName" required defaultValue={userInfo ? userInfo?.middleName : ''} />
            </div>
            <div className="col-md-4 col-6">
              <label className={classes.label} htmlFor="lastName">{t("Last Name")}</label>
              <input id="lastName" type="text" name="lastName" required defaultValue={userInfo ? userInfo?.lastName : ''} />
            </div>
          </div>

          <div className={classes.sectionHeader}>
            <FaUserTag /> {t("Account & Role")}
          </div>
          <div className="row">
            <div className="col-md-4 col-6">
              <label className={classes.label} htmlFor="userName">{t("User Name")}</label>
              <input id="userName" type="text" name="userName" required defaultValue={userInfo ? userInfo?.userName : ''} />
            </div>
            <div className="col-md-4 col-6">
              <label className={classes.label} htmlFor="role">{t("Role")}</label>
              <select id="role" name="role" defaultValue={userInfo ? userInfo.role : ''} required>
                <option value="">{t("Select Role")}</option>
                <option value="ROLE_ACCOUNTANT">{t("Accountant")} </option>
                <option value="ROLE_ADMIN">{t("Admin")} </option>
                <option value="ROLE_DOCTOR">{t("Doctor")}</option>
                <option value="ROLE_GUESTDOCTOR">{t("Guest Doctor")} </option>
                <option value="ROLE_MANAGER">{t("Manager")} </option>
                <option value="ROLE_NURSE">{t("Nurse")} </option>
                <option value="ROLE_PHARMACIST">{t("Pharmacist")} </option>
                <option value="ROLE_RECEPTIONIST">{t("Receptionist")}</option>
              </select>
            </div>
            <div className="col-md-4 col-6">
              <label className={classes.label} htmlFor="password">{t("Password")}</label>
              <input id="password" type="password" name="password" required defaultValue={userInfo ? userInfo?.password : ''} />
            </div>
          </div>

          <div className={classes.sectionHeader}>
            <FaPhoneAlt /> {t("Contact details")}
          </div>
          <div className="row">
            <div className="col-md-6 col-6">
              <label className={classes.label} htmlFor="email">{t("Email")}</label>
              <input id="email" type="email" name="email" defaultValue={userInfo ? userInfo?.email : ''} />
            </div>
            <div className="col-md-6 col-6">
              <label className={classes.label} htmlFor="mobile">{t("Mobile Number")}</label>
              <input id="mobile" type="tel" name="mobile" required defaultValue={userInfo ? userInfo?.mobile : ''} />
            </div>
          </div>

          <div className={classes.actions}>
            <button
              type="submit"
              disabled={isSubmitting}
            >
              <FaSave className="me-2" /> {isSubmitting ? t("Saving...") : t('Save Changes')}
            </button>
            <button
              type="button"
              onClick={cancelHandler}
              className={classes.secondaryBtn}
            >
              <FaTimes className="me-2" /> {t("Cancel")}
            </button>
          </div>
        </Form>
      </div>
      <ConfirmModal
        show={showUpdateConfirm}
        onHide={() => setShowUpdateConfirm(false)}
        onConfirm={confirmUpdate}
        title={t("Update User")}
        message={t("Are you sure you want to save the changes to this user information?")}
        variant="update"
        confirmText={t("Update")}
      />
    </div>
  );
}

export default EditUser;

export async function action({ request }) {
  const data = await request.formData();
  const method = request.method;
  const userData = {
    userId: data.get("userId"),
    firstName: data.get("firstName"),
    middleName: data.get("middleName"),
    lastName: data.get("lastName"),
    userName: data.get("userName"),
    email: data.get("email"),
    mobile: data.get("mobile"),
    role: data.get("role"),
    password: data.get("password"),
  };

  const token = getAuthToken();
  if (token === null || token === "EXPIRED") {
    return redirect("/");
  }

  const apiChar = getApiChara();
  const apiUrl = `${apiChar}/users/updateUser`;

  try {
    const response = await fetch(apiUrl, {
      method: "PUT",
      body: JSON.stringify(userData),
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + token,
      },
    });

    if (response.status === 403) {
      toast.error("You don't have permission to update this role.");
      return null;
    }

    if (!response.ok) {
      toast.error("Could not update user.");
      throw json(
        { message: "Could not update user." },
        { status: response.status }
      );
    }

    const responseData = await response.json();
    toast.success("User updated successfully!");
    return redirect("..");
  } catch (error) {
    console.error("There has been a problem with your fetch operation:", error);
    toast.error("Something went wrong. Please try again.");
    return null;
  }
}
